import { useEffect, useState } from 'react'
import { ultraadminBillingApi } from '@/services/api/billing'
import { Button } from '@/components/common'

export function UltraadminBillingTicketsPage() {
  const [rows, setRows] = useState<any[]>([])
  const load = () => ultraadminBillingApi.tickets().then(setRows as any)
  useEffect(() => { load() }, [])
  return (
    <div className="p-6 max-w-5xl">
      <h1 className="text-2xl font-bold mb-4">Billing-Tickets</h1>
      <table className="w-full text-sm">
        <thead><tr className="text-left border-b"><th className="py-2">Schule</th><th>Rechnung</th><th>Leben</th><th>Pause bis</th><th>Status</th><th></th></tr></thead>
        <tbody>
          {rows.map((t) => (
            <tr key={t.id} className="border-b">
              <td className="py-2">{t.school_name}</td>
              <td><a className="underline" href={`/ultraadmin/invoices?school_id=${t.school_id}`}>{t.invoice_number}</a></td>
              <td>{t.school_lifetime_index}</td>
              <td>{t.pause_until ? String(t.pause_until).slice(0, 16) : '—'}</td>
              <td>{t.status}</td>
              <td className="flex gap-2 py-2">
                {t.status === 'open' && (
                  <>
                    <Button size="sm" onClick={() => ultraadminBillingApi.resolveTicket(t.id, true).then(load)}>Annehmen</Button>
                    <Button size="sm" variant="ghost" onClick={() => ultraadminBillingApi.resolveTicket(t.id, false).then(load)}>Ablehnen</Button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
